<template>
    <CommonBox title="Upload File" @close="$emit('close')" @submit="$emit('close')">
       <el-upload
			class="upload-demo"
			ref="upload"
			:action="$http.http.defaults.baseURL + 'uploadFileSolutions'"
			:headers="header"
			:data="data"
			:auto-upload="false"
			:multiple="true"
            :before-upload="beforeUpload"
			:file-list="fileList"
			:on-success="success"
		>
		<el-button slot="trigger" size="small" type="primary">Select File</el-button>
        <br><br>
                <label style="margin-left:10px;display:inline-block;width:150px;">Industry：</label>
                <el-select style="width:200px;" v-model="data.Industry" placeholder="">
                    <el-option
                        v-for="item in industryList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>
                <br><br>

                <label style="margin-left:10px;display:inline-block;width:150px;">Document Type：</label>
                <el-select style="width:200px;" v-model="data.DocumentType" placeholder="">
                    <el-option
                        v-for="item in documentTypeList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>
                <br><br>

		<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Upload to Server</el-button>
		</el-upload>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox1.vue";
import { industryList,documentTypeList } from "@/components/Solutions/data.js";
import { unshiftAll } from "@/methods/selection.js";
export default {
    components:{
        CommonBox
    },
    props:{
    },
    data () {
        return {
            header:{},
            industryList:unshiftAll(industryList),
            documentTypeList:unshiftAll(documentTypeList),
            data:{
                Industry:"all",
                DocumentType:"all"
            },
            fileList:[]
        };
    },
    mounted () {
        this.header = {
            "x-auth-token":localStorage.getItem('producttoken')
        };
    },
    methods:{
        submitUpload () {
            this.$refs.upload.submit();
        },
        success (response) {
            if(response.code === 0) {
                this.$baseNotice.message(response.msg);
                this.$emit("success");
            }else{
                this.$baseNotice.message(response.msg,"error");
            }
        },
        beforeUpload (file) {
            if(file.size > 800 * 1024 * 1024) {
                this.$message.error("The size of "+file.name+" exceeds 800M !");
                return false;
            }
        }
    }
};
</script>
